/**
 * Created by MateuszWaligora on 14.07.2017.
 */
// import Vue from 'vue';
/**
 * @module Store/view
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {object}
 * */
const state = {
    elementsOldPath: '',
    targetPath: '',
    draggedElement: {},
    dragData: {}
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getTargetPath: state => state.targetPath,
    getElementsOldPath: state => state.elementsOldPath,
    getDraggedElement: state => state.draggedElement,
    getDragData: state => state.dragData};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    setTargetPath: (state, targetPath) => state.targetPath = targetPath,
    setDraggedElement: (state, payload) => state.draggedElement = payload,
    setElementsOldPath: (state, payload) => state.elementsOldPath = payload,
    setDragData: (state, payload) => state.dragData = payload
};

export default {
    state,
    getters,
    mutations
};
